import useRouter from "@hooks/useRouter"

import { faIcon } from "@utils/faIcon"
import isModKeyPressed from "@utils/isModKeyPressed"

import { Button, ListInfoGlyph } from "@atoms"

import styles from "@organisms/CardList/CardListEdgeStates/CardListEdgeStates.module.scss"
import useTable from "@organisms/Table/Table.context"

export default function CardListEmptyState() {
    const { push } = useRouter()

    const { tabContentName, objectCreateRoute, objectName } = useTable()

    const title = `No ${tabContentName.toLowerCase().replace("all", "")}`

    const explanation = `There are no ${tabContentName
        .toLowerCase()
        .replace("all", "")
        .replace("&", "or")} to display.`

    const onClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (isModKeyPressed(event)) {
            window.open(objectCreateRoute, "_blank", "noopener,noreferrer")
        } else {
            push(objectCreateRoute)
        }
    }

    return (
        <div className={styles.base}>
            <div className={styles.content}>
                <div className={styles.copyWrap}>
                    <ListInfoGlyph variant="black" icon={faIcon({ name: "file-lines", style: "solid" })} />
                    <div className={styles.copy}>
                        <h2 className={styles.title}>{title}</h2>
                        <p className={styles.explanation}>{explanation}</p>
                    </div>
                </div>
                <Button
                    size="lg"
                    variant="solid"
                    leftIcon={faIcon({ name: "plus", style: "solid" })}
                    onClick={onClick}
                    noDebounce={true}
                >
                    Create {objectName}
                </Button>
            </div>
        </div>
    )
}
